import { useState, useEffect } from "react";

/**
 * Persists table sort and page-size preferences to localStorage so they
 * survive page refreshes and navigation.  Each screen passes a unique
 * storageKey so preferences are stored independently.
 */
export function useTablePreferences(storageKey, defaultRowsPerPage = 10) {
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey));
      return stored?.rowsPerPage ?? defaultRowsPerPage;
    } catch {
      return defaultRowsPerPage;
    }
  });

  const [sortConfig, setSortConfig] = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey));
      return stored?.sortConfig ?? { column: null, direction: null };
    } catch {
      return { column: null, direction: null };
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ rowsPerPage, sortConfig }));
    } catch {}
  }, [storageKey, rowsPerPage, sortConfig]);

  return { rowsPerPage, setRowsPerPage, sortConfig, setSortConfig };
}
